<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body py-1">
                        <div class="row align-items-center justify-content-md-between">
                            <div class="col-md-4 col-12">
                                <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchTutorial()"/>
                            </div>
                            <div class="p-1 text-right" ngClass.sm="col-12">
                                <p class="mb-0 ">{{"TUTORIAL_UPLOADED" | translate}}: <span class="text-primary">{{filteredTutorials?.length}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-12" *ngFor="let tutorial of filteredTutorials">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-between align-items-center">
                                <h3 class="mb-0">{{tutorial.title}}</h3>
                                <button class="btn" (click)="showVideo(tutorial)"><i class="cursor-pointer" [data-feather]="'play'" size="25" ></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
